import React from 'react'

const BlockGrid = () => {
  return (
    <div  className='custom-modal-replace-new-grid'>
      
    </div>
  )
}

export default BlockGrid
